class TimeFormatter {
  constructor() {
    this.now = new Date();
  }

  timeAgo(timestamp) {
    const date = new Date(timestamp);
    const diffInSeconds = Math.floor((this.now - date) / 1000);

    if (diffInSeconds < 60) {
      return 'menos de um minuto atrás';
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return diffInMinutes === 1
        ? '1 minuto atrás'
        : `${diffInMinutes} minutos atrás`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return diffInHours === 1 ? '1 hora atrás' : `${diffInHours} horas atrás`;
    }

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) {
      return diffInDays === 1 ? '1 dia atrás' : `${diffInDays} dias atrás`;
    }

    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) {
      return diffInMonths === 1 ? '1 mês atrás' : `${diffInMonths} meses atrás`;
    }

    const diffInYears = Math.floor(diffInMonths / 12);
    return diffInYears === 1 ? '1 ano atrás' : `${diffInYears} anos atrás`;
  }

  initializeTimeFormatting() {
    console.log('Initializing time formatting...');
    const timeElements = document.querySelectorAll('.time-ago[data-timestamp]');
    console.log(`Found ${timeElements.length} elements to format.`);

    timeElements.forEach((element) => {
      const timestamp = element.getAttribute('data-timestamp');
      if (timestamp) {
        element.textContent = this.timeAgo(timestamp);
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOMContentLoaded fired.');
  const formatter = new TimeFormatter();
  formatter.initializeTimeFormatting();
});

export default TimeFormatter;
